require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-178-reorder-tasks-by-start-date.json") })
        }
      }, "path---article-178-reorder-tasks-by-start-date");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-178-reorder-tasks-by-start-date!./.cache/json/article-178-reorder-tasks-by-start-date.json
// module id = 526
// module chunks = 231608221292675